"use client";

import { useContext, useEffect } from "react";
import Sidenav from "../components/sidenav";
import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import Cookies from "js-cookie";
import BottomNav from "../components/global/BottomNav";
import ChangeTheme from "../components/global/ChangeTheme";
import { ThemeContext } from "../context/ThemeStore";
import UserAuthProfile from "../components/global/UserAuthProfile";

const Dashboard = ({ children }) => {
  const [cookies] = useCookies();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(ThemeContext);
  const isLms = sessionStorage.getItem("lms");

  // Check if we're on profile/settings pages
  const isProfilePage = location.pathname.includes("/account/") || location.pathname.includes("/profile");

  const isSolutionsPage = () => {
    const solutionsPattern = /^\/solutions\/.*$/;
    return solutionsPattern.test(location.pathname);
  };

  const handleAuthRedirect = () => {
    navigate(`/auth/login?redirect_url=${location?.pathname + location?.search}`);
  };

  useEffect(() => {
    const urlToken = new URLSearchParams(location.search).get("t");
    if (!Cookies.get("token") && !sessionStorage.getItem("token") && !urlToken) {
      handleAuthRedirect();
    }
  }, [location.search, navigate]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userProfile"));
    if (user && !user.isOnboardingDone && !isLms) navigate(`/onboarding?step=1`);
  }, [navigate, isLms]);

  return (
    <div className={isProfilePage ? "min-h-screen bg-[var(--q3-surface-default)]" : ""}>
      <UserAuthProfile />
      {!isLms && !isProfilePage && <Sidenav />}
      <ChangeTheme isLms={isLms} />
      <div className={`${isProfilePage ? "" : "main-content mb-5 mb-sm-0 pb-4 pb-sm-0"}`}>{children}</div>
      {!isLms && !isSolutionsPage() && !isProfilePage && <BottomNav />}
    </div>
  );
};

export default Dashboard;
